// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  Activity,
  LongWriteActivityResult,
  LongWriteAnswerCreateUpdate,
  LongWriteResultCreate,
  LongWriteResultDelete,
  LongWriteResultUpdate,
  LongWriteStudentResults,
  LongWritesSuiCatalogue,
  WritingProgress,
} from '../models/index'
import {
  ActivityFromJSON,
  ActivityToJSON,
  LongWriteActivityResultFromJSON,
  LongWriteActivityResultToJSON,
  LongWriteAnswerCreateUpdateFromJSON,
  LongWriteAnswerCreateUpdateToJSON,
  LongWriteResultCreateFromJSON,
  LongWriteResultCreateToJSON,
  LongWriteResultDeleteFromJSON,
  LongWriteResultDeleteToJSON,
  LongWriteResultUpdateFromJSON,
  LongWriteResultUpdateToJSON,
  LongWriteStudentResultsFromJSON,
  LongWriteStudentResultsToJSON,
  LongWritesSuiCatalogueFromJSON,
  LongWritesSuiCatalogueToJSON,
  WritingProgressFromJSON,
  WritingProgressToJSON,
} from '../models/index'

export interface ApiV1LongwritesActivitiesActivityIdGetRequest {
  activityId: string
}

export interface ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPutRequest {
  activityId: string
  activityResultId: string
  activityAnswerId: string
  longWriteAnswerCreateUpdate?: LongWriteAnswerCreateUpdate
}

export interface ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdDeleteRequest {
  activityId: string
  activityResultId: string
  longWriteResultDelete?: LongWriteResultDelete
}

export interface ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdGetRequest {
  activityId: string
  activityResultId: string
}

export interface ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdPostRequest {
  activityId: string
  activityResultId: string
  longWriteResultCreate?: LongWriteResultCreate
}

export interface ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdPutRequest {
  activityId: string
  activityResultId: string
  longWriteResultUpdate?: LongWriteResultUpdate
}

export interface ApiV1LongwritesCatalogueGetRequest {
  gradePosition?: number
}

export interface ApiV1LongwritesStudentsStudentIdResultsGetRequest {
  studentId: string
  progress?: WritingProgress
  skip?: number
  take?: number
}

/**
 *
 */
export class LongWritesApi extends runtime.BaseAPI {
  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdGetRaw(
    requestParameters: ApiV1LongwritesActivitiesActivityIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Activity>> {
    if (
      requestParameters.activityId === null ||
      requestParameters.activityId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityId',
        'Required parameter requestParameters.activityId was null or undefined when calling apiV1LongwritesActivitiesActivityIdGet.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/activities/{activityId}`.replace(
          `{${'activityId'}}`,
          encodeURIComponent(String(requestParameters.activityId)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ActivityFromJSON(jsonValue),
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdGet(
    requestParameters: ApiV1LongwritesActivitiesActivityIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Activity> {
    const response = await this.apiV1LongwritesActivitiesActivityIdGetRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPutRaw(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.activityId === null ||
      requestParameters.activityId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityId',
        'Required parameter requestParameters.activityId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPut.',
      )
    }

    if (
      requestParameters.activityResultId === null ||
      requestParameters.activityResultId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityResultId',
        'Required parameter requestParameters.activityResultId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPut.',
      )
    }

    if (
      requestParameters.activityAnswerId === null ||
      requestParameters.activityAnswerId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityAnswerId',
        'Required parameter requestParameters.activityAnswerId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPut.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/activities/{activityId}/results/{activityResultId}/answers/{activityAnswerId}`
          .replace(
            `{${'activityId'}}`,
            encodeURIComponent(String(requestParameters.activityId)),
          )
          .replace(
            `{${'activityResultId'}}`,
            encodeURIComponent(String(requestParameters.activityResultId)),
          )
          .replace(
            `{${'activityAnswerId'}}`,
            encodeURIComponent(String(requestParameters.activityAnswerId)),
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: LongWriteAnswerCreateUpdateToJSON(
          requestParameters.longWriteAnswerCreateUpdate,
        ),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPut(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiV1LongwritesActivitiesActivityIdResultsActivityResultIdAnswersActivityAnswerIdPutRaw(
      requestParameters,
      initOverrides,
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdDeleteRaw(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.activityId === null ||
      requestParameters.activityId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityId',
        'Required parameter requestParameters.activityId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdDelete.',
      )
    }

    if (
      requestParameters.activityResultId === null ||
      requestParameters.activityResultId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityResultId',
        'Required parameter requestParameters.activityResultId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdDelete.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/activities/{activityId}/results/{activityResultId}`
          .replace(
            `{${'activityId'}}`,
            encodeURIComponent(String(requestParameters.activityId)),
          )
          .replace(
            `{${'activityResultId'}}`,
            encodeURIComponent(String(requestParameters.activityResultId)),
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
        body: LongWriteResultDeleteToJSON(
          requestParameters.longWriteResultDelete,
        ),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdDelete(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiV1LongwritesActivitiesActivityIdResultsActivityResultIdDeleteRaw(
      requestParameters,
      initOverrides,
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdGetRaw(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LongWriteActivityResult>> {
    if (
      requestParameters.activityId === null ||
      requestParameters.activityId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityId',
        'Required parameter requestParameters.activityId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdGet.',
      )
    }

    if (
      requestParameters.activityResultId === null ||
      requestParameters.activityResultId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityResultId',
        'Required parameter requestParameters.activityResultId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdGet.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/activities/{activityId}/results/{activityResultId}`
          .replace(
            `{${'activityId'}}`,
            encodeURIComponent(String(requestParameters.activityId)),
          )
          .replace(
            `{${'activityResultId'}}`,
            encodeURIComponent(String(requestParameters.activityResultId)),
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LongWriteActivityResultFromJSON(jsonValue),
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdGet(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LongWriteActivityResult> {
    const response =
      await this.apiV1LongwritesActivitiesActivityIdResultsActivityResultIdGetRaw(
        requestParameters,
        initOverrides,
      )
    return await response.value()
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPostRaw(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.activityId === null ||
      requestParameters.activityId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityId',
        'Required parameter requestParameters.activityId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPost.',
      )
    }

    if (
      requestParameters.activityResultId === null ||
      requestParameters.activityResultId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityResultId',
        'Required parameter requestParameters.activityResultId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPost.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/activities/{activityId}/results/{activityResultId}`
          .replace(
            `{${'activityId'}}`,
            encodeURIComponent(String(requestParameters.activityId)),
          )
          .replace(
            `{${'activityResultId'}}`,
            encodeURIComponent(String(requestParameters.activityResultId)),
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LongWriteResultCreateToJSON(
          requestParameters.longWriteResultCreate,
        ),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPost(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPostRaw(
      requestParameters,
      initOverrides,
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPutRaw(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.activityId === null ||
      requestParameters.activityId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityId',
        'Required parameter requestParameters.activityId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPut.',
      )
    }

    if (
      requestParameters.activityResultId === null ||
      requestParameters.activityResultId === undefined
    ) {
      throw new runtime.RequiredError(
        'activityResultId',
        'Required parameter requestParameters.activityResultId was null or undefined when calling apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPut.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/activities/{activityId}/results/{activityResultId}`
          .replace(
            `{${'activityId'}}`,
            encodeURIComponent(String(requestParameters.activityId)),
          )
          .replace(
            `{${'activityResultId'}}`,
            encodeURIComponent(String(requestParameters.activityResultId)),
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: LongWriteResultUpdateToJSON(
          requestParameters.longWriteResultUpdate,
        ),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPut(
    requestParameters: ApiV1LongwritesActivitiesActivityIdResultsActivityResultIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiV1LongwritesActivitiesActivityIdResultsActivityResultIdPutRaw(
      requestParameters,
      initOverrides,
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesCatalogueGetRaw(
    requestParameters: ApiV1LongwritesCatalogueGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LongWritesSuiCatalogue>> {
    const queryParameters: any = {}

    if (requestParameters.gradePosition !== undefined) {
      queryParameters['gradePosition'] = requestParameters.gradePosition
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/catalogue`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LongWritesSuiCatalogueFromJSON(jsonValue),
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement) (Auth policies: AnyRoleRequirement)
   */
  async apiV1LongwritesCatalogueGet(
    requestParameters: ApiV1LongwritesCatalogueGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LongWritesSuiCatalogue> {
    const response = await this.apiV1LongwritesCatalogueGetRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   *  (Auth policies: AnyRoleRequirement, StudentResourceRequirement) (Auth policies: AnyRoleRequirement, StudentResourceRequirement)
   */
  async apiV1LongwritesStudentsStudentIdResultsGetRaw(
    requestParameters: ApiV1LongwritesStudentsStudentIdResultsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LongWriteStudentResults>> {
    if (
      requestParameters.studentId === null ||
      requestParameters.studentId === undefined
    ) {
      throw new runtime.RequiredError(
        'studentId',
        'Required parameter requestParameters.studentId was null or undefined when calling apiV1LongwritesStudentsStudentIdResultsGet.',
      )
    }

    const queryParameters: any = {}

    if (requestParameters.progress !== undefined) {
      queryParameters['progress'] = requestParameters.progress
    }

    if (requestParameters.skip !== undefined) {
      queryParameters['skip'] = requestParameters.skip
    }

    if (requestParameters.take !== undefined) {
      queryParameters['take'] = requestParameters.take
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/longwrites/students/{studentId}/results`.replace(
          `{${'studentId'}}`,
          encodeURIComponent(String(requestParameters.studentId)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LongWriteStudentResultsFromJSON(jsonValue),
    )
  }

  /**
   *  (Auth policies: AnyRoleRequirement, StudentResourceRequirement) (Auth policies: AnyRoleRequirement, StudentResourceRequirement)
   */
  async apiV1LongwritesStudentsStudentIdResultsGet(
    requestParameters: ApiV1LongwritesStudentsStudentIdResultsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LongWriteStudentResults> {
    const response = await this.apiV1LongwritesStudentsStudentIdResultsGetRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }
}
